import { TextField } from "@mui/material";
import React from "react";
import { useEffect, useRef } from "react";
import { inputPropsStyle, textFielsStyle } from "./style";
import { useThemeContext } from "../../../globalContext/global-context";
interface MultiInputsComponentsProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  colIndex: number;
  rowIndex: number;
  value?: string | number;
  ariaLabel?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const MultiInputsComponents = ({
  onChange,
  colIndex,
  rowIndex,
  value,
  ariaLabel,
  onKeyDown,
}: MultiInputsComponentsProps) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (rowIndex === 0 && colIndex === 0)
      inputRef.current?.focus({ preventScroll: true });
  }, [rowIndex, colIndex]);

  return (
    <TextField
      data-testid={`Numeric-grid-input-${rowIndex + 1}-${colIndex + 1}`}
      onChange={onChange}
      onKeyDown={onKeyDown}
      value={value ?? ""}
      fullWidth
      sx={textFielsStyle(theme)}
      inputRef={inputRef}
      type="number"
      slotProps={{
        htmlInput: ariaLabel ? { "aria-label": ariaLabel } : {},
        input: {
          type: "number",
          sx: inputPropsStyle,
        },
      }}
    />
  );
};

export default MultiInputsComponents;
